import { createContext, useCallback, useContext, useEffect, useState } from "react";

const STORAGE_KEY = "tz_consent"; // "accepted" | "rejected" | null
const ConsentContext = createContext({
  status: null,
  accept: () => {},
  reject: () => {},
  reset: () => {},
  open: false,
  setOpen: () => {},
});

export function ConsentProvider({ children }) {
  const [status, setStatus] = useState(null);
  const [open, setOpen] = useState(false);

  // Bootstrap from storage
  useEffect(() => {
    try {
      const v = window.localStorage.getItem(STORAGE_KEY);
      if (v === "accepted" || v === "rejected") {
        setStatus(v);
      } else {
        setStatus(null);
        setOpen(true); // first visit → show banner
      }
    } catch {
      // private mode etc
      setStatus(null);
    }
  }, []);

  const persist = useCallback((v) => {
    try { window.localStorage.setItem(STORAGE_KEY, v); } catch { /* ignore */ }
    setStatus(v);
    setOpen(false);
  }, []);

  const accept = useCallback(() => persist("accepted"), [persist]);
  const reject = useCallback(() => persist("rejected"), [persist]);
  const reset = useCallback(() => {
    try { window.localStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
    setStatus(null);
    setOpen(true);
  }, []);

  return (
    <ConsentContext.Provider value={{ status, accept, reject, reset, open, setOpen }}>
      {children}
    </ConsentContext.Provider>
  );
}

export const useConsent = () => useContext(ConsentContext);
